export type Swatch = {
  hex: string;
  hsl: [number, number, number];
  lab: [number, number, number];
  weight: number;
};

export type Colors = {
  dominant: string;
  palette: Swatch[];
};

export type CoordItem = {
  name: string;
  id: string;
  url: string;
  point: string;
  term: string;
  category: string | null;
  brand: string;
  colors?: Colors;
  owned?: boolean;
  qr?: string;
  setQR?: string;
  usableInAipri?: boolean | null;
  available?: boolean | null;
  primagi?: {
    itemId: number;
    chapter: string;
    sealId?: string;
    brandId: number | null;
    rarityId: number | null;
    genreId: number | null;
    colorId: number | null;
    subCategoryId: number | null;
    kinds: string;
  };
};

export type CoordEntry = {
  key: string;
  name: string;
  url: string;
  star: string;
  brand: string;
  category: string | null;
  items: CoordItem[];
  colors?: Colors;
  series?: "aipri" | "primagi";
  chapter?: string;
  sourceUrl?: string;
  usableInAipri?: boolean | null;
  available?: boolean | null;
  mix?: {
    id: string;
    scope: "local" | "global";
  };
};

export const GROUP_ORDER = [
  "アクセ",
  "トップス",
  "ワンピ",
  "ボトムス",
  "シューズ",
] as const;

export type CompareGroup = (typeof GROUP_ORDER)[number];

export type Selection = Record<CompareGroup, CoordItem[]>;

export type FacetOption = {
  value: string;
  label?: string;
  count: number;
};

export type NormalFilters = {
  query: string;
  brands: ReadonlySet<string>;
  terms: ReadonlySet<string>;
  categories: ReadonlySet<string>;
};

export type ColorSchemeType =
  | "analogous"
  | "complementary"
  | "split-complement"
  | "triadic"
  | "tetradic";

export type HslColorFilter = {
  hue: number;
  saturation: number;
  lightness: number;
};

export const COLOR_SEARCH_TARGETS = [
  "全身",
  "アクセ",
  "ワンピ",
  "トップス",
  "ボトムス",
  "シューズ",
] as const;

export type ColorSearchTarget = (typeof COLOR_SEARCH_TARGETS)[number];
export type PaletteRankLimit = 1 | 2 | 3 | 4 | 5;

export interface ColorFilters {
  hslColors: HslColorFilter[];
  colorMatchTolerance: number;
  paletteRankLimit: PaletteRankLimit;
  targets: ColorSearchTarget[];
}

export type LoadResult = {
  entries: CoordEntry[];
  errors: string[];
};
